import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import firebase from 'firebase';
import authAction from '@iso/redux/auth/actions';

export const SESSION_EXPIRED_KEY = 'session_expired';

// The route guard trusts the id_token kept in localStorage, but Firestore only answers a signed-in
// Firebase user. When that Firebase session is gone (signed out in another tab, cleared site data,
// revoked) the panel used to stay "logged in" and show every list empty. Here such a session is
// closed and the user lands on the sign-in page with an explanation.
// localStorage, not the store: a normal logout clears the keys BEFORE signing out of Firebase.
export default function SessionGuard() {
  const dispatch = useDispatch();
  useEffect(() => firebase.auth().onAuthStateChanged((user) => {
    if (user || !localStorage.getItem('id_token')) return;
    try {
      sessionStorage.setItem(SESSION_EXPIRED_KEY, '1');
    } catch (e) {
      // the message is a nicety; the logout is what matters
    }
    dispatch(authAction.logout());
  }), [dispatch]);
  return null;
}
